import React, { useContext, useEffect, useState } from 'react'
import { CustomModal } from '../../CustomModal/CustomModal';
import { Button, Spinner } from 'reactstrap';
import { t } from 'i18next';
import { EmptyStateOne } from '../../Empty/EmptyStateOne';
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';
import buildingSuccessIcon from '../../../assets/icons/building-success-icon.svg';
import { getCurrentItems } from '../../../helpers/helpers';
import CustomPagination from '../../CustomPagination/CustomPagination';
import AreasManagementContext from '../../../context/AreasManagementContext/AreasManagementContext';
import { AreaSearcher } from './AreaSearcher';
import { ListOfAreas } from './ListOfAreas';

export const AreasManagement = () => {

    const { areasManagementState, getAreasManagement, cleanAreaState, deleteArea } = useContext(AreasManagementContext);
    const { areasToConfig, responseAreaService, isFetching } = areasManagementState;

    const [options, setOptions] = useState([]);

    const [showWarningModalToDelete, setShowWarningModalToDelete] = useState({
        active: false,
        area: {}
    });

    const [pageNumber, setPageNumber] = useState(1);

    const itemsPerPage = 10;

    const currentAreas = getCurrentItems(options, pageNumber, itemsPerPage)

    const totalPages = Math.ceil(options.length / itemsPerPage);

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
    };

    const handleChangeSearchText = async (value) => {
        if (areasToConfig.length) {
            value = value.toLowerCase();

            const filteredObjects = areasToConfig.filter((opt) => {
                return opt.areaDescription.toLowerCase().includes(value) || opt.areaCode.toLowerCase().includes(value) || opt.Building?.buildingDescription.toLowerCase().includes(value);
            });

            setOptions(filteredObjects);
        }
    }

    const openWarningModalToDelete = (area) => setShowWarningModalToDelete({ active: true, area: area });
    const closeWarningModalToDelete = async () => setShowWarningModalToDelete({ active: false, area: {} });

    const deleteBuildingAndRefresh = async () => {
        closeWarningModalToDelete();
        await deleteArea(showWarningModalToDelete.area.areaId);
    }

    const undertoodAndRefresh = async () => await getAreasManagement();

    useEffect(() => {
        getAreasManagement();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setOptions(areasToConfig);
        cleanAreaState();
        // eslint-disable-next-line
    }, [areasToConfig]);

    return (
        <>

            <CustomModal showModal={responseAreaService.show} centered={true} setShowModal={undertoodAndRefresh}>
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <img src={responseAreaService.type === 'ERROR' ? errorIcon : buildingSuccessIcon} alt="" />
                    <p className='mt-3 text-center param-section-title'>{responseAreaService.text}</p>
                    <p type="button" className='custom-modal-btn-ok' onClick={undertoodAndRefresh}>{t('UNDERSTOOD')}</p>
                </div>
            </CustomModal>

            <CustomModal showModal={showWarningModalToDelete.active} centered={true} setShowModal={closeWarningModalToDelete}>
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <img src={errorIcon} alt="" />
                    <p className='mt-3 text-center param-section-title'>{`${t('ARE_YOU_SURE_DELETE')} ${showWarningModalToDelete.area.areaCode} - ${showWarningModalToDelete.area.areaDescription} ?`}</p>
                </div>
                <div className='d-flex align-items-center justify-content-around'>
                    <div>
                        <p type='button' className='m-0' onClick={() => closeWarningModalToDelete()}>{t('CANCEL')}</p>
                    </div>
                    <div>
                        <Button style={{ color: '#FFFF' }} className='btn-danger' onClick={() => deleteBuildingAndRefresh()}>
                            {t('DELETE')}
                        </Button>
                    </div>
                </div>
            </CustomModal >

            <AreaSearcher handleChangeSearchText={handleChangeSearchText} />

            {isFetching ?
                <div className="d-flex mt-4 justify-content-center">
                    <Spinner />
                </div>

                :

                <div className='itemsList'>
                    {
                        currentAreas.length ?
                            currentAreas.map((area, i) => {
                                return (
                                    <div key={i} className='mb-2'>
                                        <ListOfAreas
                                            area={area}
                                            openWarningModalToDelete={openWarningModalToDelete}
                                        />
                                    </div>
                                )
                            })
                            : <div><EmptyStateOne message={t('NO_DATA_SEARCH')} /></div>
                    }
                </div>
            }

            <div className="d-flex justify-content-center">
                <CustomPagination
                    totalPages={totalPages}
                    page={pageNumber}
                    setPage={handlePageChange}
                />
            </div>
        </>
    )
}
